import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import productParam from '@/utils/vipRedirect'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    meta: {
        keepAlive:true,
        title: '积分兑换'
    },
    component: () => import('../views/Home.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    meta: {
        title: '积分详情'
    },
    component: () => import('../views/Detail.vue')
  },
  {
    path: '/orderList',
    name: 'orderList',
    meta:{
        keepAlive:true,
        title: '积分订单'
    },
    component: () => import('../views/OrderList.vue')
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    meta:{
        title: '订单详情'
    },
    component: () => import('../views/OrderDetail.vue')
  },
  {
    path: '/orderDetailDTC',
    name: 'orderDetailDTC',
    meta:{
        title: '订单详情'
    },
    component: () => import('../views/OrderDetailDTC.vue')
  },
  {
    path: '/orderConfirm',
    name: 'orderConfirm',
    meta:{
        title: '确认订单'
    },
    component: () => import('../views/OrderConfirm.vue')
  },
  {
    path: '/exchangeSuccess',
    name: 'exchangeSuccess',
    meta:{
        title: '兑换成功'
    },
    component: () => import('../views/ExchangeSuccess.vue')
  },{
    path: '/pointsDetails',
    name: 'pointsDetails',
    meta:{
        title: '积分详情'
    },
    component: () => import('../views/PointsDetails.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to) => {

    let str = new URL(window.location.href);
    // if (!(to.query?.code || str.searchParams.get('code') != '0' || Number(str.searchParams.get('code')) !== 0)) {
    //     if (!to.query?.authCode && to.path === '/') {
    //         if(str.searchParams.get('authCode')) {
    //             location.href = str.origin + str.pathname + str.hash + str.search;
    //         }else {
    //             if(str.search.indexOf('brand=') > -1) {
    //                 const _brand = str.search.split('brand=')[1]
    //                 location.href = productParam(_brand);
    //             }else {
    //                 if(str.searchParams.get('code') != '0' || Number(str.searchParams.get('code')) !== 0) {
    //                     location.href = str.origin + str.pathname + str.hash + str.search;
    //                 }
    //             }
    //         }
    //     }else {
    //         if(str.searchParams.get('authCode')) {
    //             location.href = str.origin + str.pathname + str.hash + str.search;
    //         }
    //     }
    // }else {
    //     if(str.search.indexOf('brand=') > -1) {
    //         const _brand = str.search.split('brand=')[1]
    //         location.href = productParam(_brand);
    //     }else {
    //         location.href = str.origin + str.pathname + str.hash + str.search;
    //     }
    // }

    // 如果存在vipUid 判断当前是否缓存 如果相同 走 用户信息判断
    // if(str.search.indexOf('vipruid=') > -1) {
    //     const _paramsVipId = str.search.split('vipruid=')[1];
    //     if(_paramsVipId) {
    //         const _brandVipUserId = _paramsVipId.split('&')[0];
    //         if(window.localStorage.getItem('vipUserId') === _brandVipUserId) {
    //             if(window.localStorage.getItem('userInfo') != 'undefined' && window.localStorage.getItem('userInfo') != 'null'
    //             && window.localStorage.getItem('userInfo')) {
    //                 if(str.search) {
    //                     const _params = str.search.split('brand=')[1];
    //                     if(_params) {
    //                         const _brand = _params.split('&')[0];
    //                         if(window.localStorage.getItem(_brand)) {
    //                             location.href = str.origin + str.pathname + '#/?state=' + _brand + '&openId=' + window.localStorage.getItem(_brand);

    //                             if (to.meta.title) { // 判断是否有标题
    //                                 document.title = to.meta.title as string;
    //                             }

    //                             return;
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }

    if(window.localStorage.getItem('userInfo') != 'undefined' && window.localStorage.getItem('userInfo') != 'null'
    && window.localStorage.getItem('userInfo')) {
        if(str.search) {
            const _params = str.search.split('brand=')[1];
            if(_params) {
                const _brand = _params.split('&')[0];
                if(window.localStorage.getItem(_brand)) {
                    if(str.search.indexOf('vipruid=') > -1) {
                        const _paramsVipId = str.search.split('vipruid=')[1];
                        if(_paramsVipId) {
                            const _brandVipUserId = _paramsVipId.split('&')[0];
                            // alert('vipuserId' + _brandVipUserId + _brand)
                            // alert(window.localStorage.getItem('vipuserId' + _brandVipUserId + _brand))
                            // alert('_brandVipUserId==' + _brandVipUserId)
                            if(window.localStorage.getItem('vipuserId' + _brandVipUserId + _brand) === _brandVipUserId) {
                                // alert(location.href)
                                location.href = str.origin + str.pathname + '#/?state=' + _brand + '&openId=' + window.localStorage.getItem(_brand);

                                if (to.meta.title) { // 判断是否有标题
                                    document.title = to.meta.title as string;
                                }

                                return;
                            }
                        }
                    }else {
                        location.href = str.origin + str.pathname + '#/?state=' + _brand + '&openId=' + window.localStorage.getItem(_brand);

                        if (to.meta.title) { // 判断是否有标题
                            document.title = to.meta.title as string;
                        }

                        return;
                    }
                }
            }
        }
    }

    if(str.search.indexOf('openId=') > -1 ) {
        const _params = str.search.split('brand=')[1];
        if(_params) {
            const _brand = _params.split('&')[0]
            if(window.localStorage.getItem(_brand)) {
                location.href = str.origin + str.pathname + str.hash + str.search;
            }
        }
    }else {
        if(str.search.indexOf('brand=') > -1) {
            const _params = str.search.split('brand=')[1];
            const _brand = _params.split('&')[0];
            if(str.search.indexOf('vipruid=') > -1) {
                const _paramsVipId = str.search.split('vipruid=')[1];
                const _brandVipUserId = _paramsVipId.split('&')[0];
                // alert('2vipuserId' + _brandVipUserId + _brand)
                // alert(window.localStorage.getItem('vipuserId' + _brandVipUserId + _brand))
                // alert('2_brandVipUserId==' + _brandVipUserId)
                if(window.localStorage.getItem('vipuserId' + _brandVipUserId + _brand) !== _brandVipUserId) {
                    window.localStorage.setItem('vipuserId' + _brandVipUserId + _brand, '');
                    window.localStorage.setItem(_brand, '');
                }
                window.localStorage.setItem('vipuserId' + _brandVipUserId + _brand, _brandVipUserId);
            }
            location.href = productParam(_brand);
        }else {
            if(str.searchParams.get('authCode') || str.searchParams.get('openId')) {
                location.href = str.origin + str.pathname + str.hash + str.search;
            }
        }
    }

    if (to.meta.title) { // 判断是否有标题
        document.title = to.meta.title as string;
    }
});


export default router
